<script setup lang="ts">
import type { CtaData } from '~/utils/crystallize/pieces'
import { NuxtLink } from '#components'
import { getCtaProps } from '~/utils/crystallize/cta'

const props = defineProps<{
  data: CtaData
}>()

const cta = computed(() => getCtaProps(props.data))

// Default state: Both illustration and image are missing, or the illustration is explicitly set to 'justitia'
const isDefaultVariant = computed(() => (!cta.value.illustration && !cta.value.image) || cta.value.illustration === 'justitia')
</script>

<template>
  <div
    class="flex rounded-2xl @container"
    :class="[
      isDefaultVariant ? 'bg-blurple-200 gap-l p-m' : 'items-center justify-between my-0 lg:px-xl',
      {
        'gap-5xl': !!cta.image,
        'gap-xl': !isDefaultVariant && !!cta.illustration,
      },
    ]"
  >
    <div v-if="isDefaultVariant" class="hidden @xl:block min-w-[250px] self-end -mb-m ml-[-100px] min-h-[300px] h-[300px] -mt-xl">
      <IllustrationJustitia class="size-full" />
    </div>
    <div class="flex flex-col gap-s">
      <h4 v-if="cta.title" :class="{ 'title-l': !isDefaultVariant }" v-text="cta.title" />
      <CrystallizeRichText v-for="(block, i) in cta.text" :key="i" :block="block" />
      <Button :is="NuxtLink" v-if="cta.action" class="mt-s" color="moss" variant="primary" :to="cta.action.link">
        {{ cta.action.label || cta.action.link }}
      </Button>
    </div>
    <CrystallizeClippedImage
      v-if="cta.image"
      :image="cta.image"
      path="hexagon-left"
      class="hidden @xl:block shrink-0 my-m"
      img-class="rounded-r-3xl object-cover object-center max-h-80 w-full"
    />
    <StaticIllustration
      v-else-if="cta.illustration"
      class="hidden @2xl:block self-end -mb-3xl -mr-xl"
      :name="cta.illustration"
    />
  </div>
</template>
